import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { getChecklistItemList } from "api/checklistItems";
import BaseTable from "components/DataTable/BaseTable";
import ListingImageCol from "components/ListingImageCol";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { STATUS_ACTIVE } from "utils/helper";

const TABLE_COLUMNS = [
    { id: "name", Header: "Name", accessor: "name", align: "left", sortable: true },
    { id: "type", Header: "Type", accessor: "type", align: "left" },
    { id: "ride", Header: "Ride", accessor: "ride", align: "left" },
    { id: "category", Header: "Category", accessor: "category", align: "left" },
    // { id: "created_at", Header: "Created At", accessor: "created_at", align: "left", sortable: true },
    { id: "status", Header: "Status", accessor: "status", align: "left" },
];

export const parentRoute = '/checklist-items';

function ChecklistItemTable() {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshKey] = useState(0);

    const savedState = location.state || { sort: "created_at", dir: "desc" };

    const createTableRow = useCallback((item) => ({
        name: <ListingImageCol imgUrl={item.img_filename} name={item.name} />,
        type: <MDTypography component="div" variant="standard" color="text">{item.type?.name}</MDTypography>,
        ride: <MDTypography component="div" variant="standard" color="text">{item.ride_id?.name}</MDTypography>,
        category: <MDTypography component="div" variant="standard" color="text">{item.category?.name}</MDTypography>,
        // created_at: <MDTypography component="div" variant="standard" color="text">
        //     {formatDateTime(item.created_at)}
        // </MDTypography>,
        status: <MDTypography component="div" variant="standard" color={item.status?.id === STATUS_ACTIVE ? "success" : "error"}>
            {item.status?.name}
        </MDTypography>
    }), []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <BaseTable
                key={refreshKey}
                title="Checklist Management"
                columns={TABLE_COLUMNS}
                fetchData={getChecklistItemList}
                defaultState={savedState}
                createTableRow={createTableRow}
                showAddButton
                addButtonText="Add Checklist Item"
                onAddClick={() => navigate(`${parentRoute}/add-checklist`, { state: savedState })}
                showSearch
                showStatusFilter
                showRideFilter
                showFrequencyTypeFilter
                showInspectionCategoryFilter
                searchPlaceholder="Search checklist name..."
                onClickRow={(row, key) => { navigate(`${parentRoute}/${row.id}`, { state: savedState }) }}
            />
        </DashboardLayout>
    );
}

export default ChecklistItemTable;